import { SitecoreContextValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { BlogPostData, BlogTopic, BlogTopicData } from 'models/blog-types';
import { NextRouter } from 'next/router';
import { useCallback } from 'react';

export const getDatabaseName = (sitecoreContext: SitecoreContextValue) => {
  let databaseName = sitecoreContext.route?.databaseName || '';
  const siteName = sitecoreContext.site?.name || '';

  if (siteName.indexOf('_preview') > 0) {
    databaseName = 'preview';
  }

  return databaseName;
};

export const getUniqueSortedTopics = (posts: BlogPostData[]): BlogTopicData[] => {
  const topicMap = new Map<string, BlogTopicData>();

  posts.forEach((post) => {
    post.blogTopics.forEach((topic) => {
      if (topic.topic && topic.topic !== '$name' && !topicMap.has(topic.id)) {
        topicMap.set(topic.id, topic);
      }
    });
  });

  // Convert to array and sort by `topic` field
  return Array.from(topicMap.values()).sort((a, b) => (a.topic || '').localeCompare(b.topic || ''));
};

export const useTopicFilter = (router: NextRouter) => {
  const updateTopicsInUrl = useCallback(
    (selectedTopics: BlogTopicData[]) => {
      const selectedIds = selectedTopics.map((t) => t.id);
      const queryParams = new URLSearchParams(window.location.search);

      if (selectedIds.length > 0) {
        queryParams.set('topics', selectedIds.join(','));
      } else {
        queryParams.delete('topics');
      }
      const queryString = queryParams.toString();
      const finalUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;

      router.push(finalUrl, undefined, { shallow: true });
    },
    [router]
  );

  return updateTopicsInUrl;
};

export const filterPostsByTopic = (posts: BlogPostData[], topics?: BlogTopicData[]): BlogPostData[] => {
  if (topics?.length) {
    const topicIds = topics.map((topic) => topic.id);
    posts = posts.filter((post) => post.blogTopics?.length && post.blogTopics.some((x) => topicIds.includes(x.id)));
  }

  return posts;
};

export const getTopicTooltip = (topic?: BlogTopic, tooltipText = '', topicText = '') => {
  let tooltip = tooltipText || `${topic?.fields?.tooltip.value}`;
  tooltip = tooltip.replace('{topic}', topicText || `${topic?.fields?.topic.value}`);

  return tooltip;
};

export const removeTopicFromFilter = (topicId: string) => {
  const $element = document.getElementById(topicId);
  $element?.click();
};
